import { IBlock } from "../../../../../framework/src/IBlock";
import { Message } from "../../../../../framework/src/Message";
import { BlockComponent } from "../../../../../framework/src/BlockComponent";
import MessageEnum, {
  getName
} from "../../../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../../../framework/src/RunEngine";

// Customizable Area Start
import StorageProvider from "../../../../../framework/src/StorageProvider";
// Customizable Area End

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  managersData: any;
  query: string;
  searchData:any;
  serachQuery:string
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class ValidateManagerController extends BlockComponent<Props, S, SS> {
  apiContactPriorityId: any;
  apigetValidateManagerId: any;
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.state = {
      managersData: null,
      query: '',
      searchData: null,
      serachQuery:''
    };

    // Customizable Area Startg
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage)];
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
   if (
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      this.apigetValidateManagerId !== null &&
      this.apigetValidateManagerId ===
        message.getData(getName(MessageEnum.RestAPIResponceDataMessage))
    ) {
      this.apigetValidateManagerId = null;
      var responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      var errorReponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );
      if (responseJson && responseJson.data) {
        this.getValidateManagerSuccess(responseJson.data);
      } else {
        //Check Error Response
        this.getValidateManagerFail();
        this.parseApiErrorResponse(responseJson);
      }
      this.parseApiCatchErrorResponse(errorReponse);
    }
    // Customizable Area End
  }
  handleSearch = (text : any) => {
    this.setState({query:text})
     if(text !== "") {
           const newData = this.state.managersData.filter((name: any) => {
           return Object.values(name.attributes)
                 .join(" ")
                 .toLowerCase()
                 .includes(text.toLowerCase());
           });
           this.setState({searchData:newData});
           console.log(newData);

     } else {
       this.setState({searchData:this.state.managersData});
     }
   };
  // Customizable Area Start
  async componentDidMount() {
    super.componentDidMount();
    this.getValidateManager();
  }
  getValidateManager = async () => {
    const header = {
      "Content-Type": "application/json",
      token: localStorage.getItem("authToken")
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.apigetValidateManagerId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      "bx_block_material_manager/material_manager/pending_managers"
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);

    return true;
  };
  getValidateManagerSuccess = (data: any) => {
    this.setState({ managersData: data });
  };

  getValidateManagerFail = () => {};

  // Customizable Area End
}
